import React from 'react';
import Icon from '../../../components/AppIcon';

const ViewToggle = ({ activeView, onViewChange }) => {
  return (
    <div className="lg:hidden fixed bottom-20 left-1/2 -translate-x-1/2 z-50 bg-card rounded-full shadow-warm-lg p-1 flex items-center gap-1">
      <button
        onClick={() => onViewChange('map')}
        className={`px-4 py-2 rounded-full flex items-center gap-2 transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 ${
          activeView === 'map' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:bg-muted'
        }`}
        aria-label="Vista mappa"
      >
        <Icon name="Map" size={18} />
        <span className="font-caption text-sm font-medium">Mappa</span>
      </button>
      <button
        onClick={() => onViewChange('list')}
        className={`px-4 py-2 rounded-full flex items-center gap-2 transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 ${
          activeView === 'list' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:bg-muted'
        }`}
        aria-label="Vista lista"
      >
        <Icon name="List" size={18} />
        <span className="font-caption text-sm font-medium">Lista</span>
      </button>
    </div>
  );
};

export default ViewToggle;